import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './Settings.css';

const Settings = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('account');
  const [notifications, setNotifications] = useState({
    emailBids: true,
    emailMessages: true,
    emailReports: false,
    pushBids: true,
    pushMessages: true
  });
  const [passwordData, setPasswordData] = useState({
    current: '',
    new: '',
    confirm: ''
  });
  const [language, setLanguage] = useState('en');
  const [currency, setCurrency] = useState('USD');

  const handlePasswordChange = (e) => {
    e.preventDefault();
    if (passwordData.new !== passwordData.confirm) {
      alert('New passwords do not match');
      return;
    }
    alert('Password changed successfully!');
    setPasswordData({ current: '', new: '', confirm: '' });
  };

  const handleNotificationToggle = (key) => {
    setNotifications({ ...notifications, [key]: !notifications[key] });
  };

  return (
    <div className="settings-page">
      <h1>Settings</h1>
      <p className="settings-subtitle">Manage your account preferences</p>

      <div className="settings-tabs">
        <button className={`tab ${activeTab === 'account' ? 'active' : ''}`} onClick={() => setActiveTab('account')}>
          <i className="fas fa-user"></i> Account
        </button>
        <button className={`tab ${activeTab === 'notifications' ? 'active' : ''}`} onClick={() => setActiveTab('notifications')}>
          <i className="fas fa-bell"></i> Notifications
        </button>
        <button className={`tab ${activeTab === 'security' ? 'active' : ''}`} onClick={() => setActiveTab('security')}>
          <i className="fas fa-shield-alt"></i> Security
        </button>
        <button className={`tab ${activeTab === 'preferences' ? 'active' : ''}`} onClick={() => setActiveTab('preferences')}>
          <i className="fas fa-globe"></i> Preferences
        </button>
      </div>

      {/* Account Tab */}
      {activeTab === 'account' && (
        <div className="settings-card">
          <h3>Account Information</h3>
          <div className="settings-form">
            <div className="form-group">
              <label>Email Address</label>
              <input type="email" value={user?.email || ''} disabled />
              <small>Email cannot be changed</small>
            </div>
            <div className="form-group">
              <label>Display Name</label>
              <input type="text" value={user?.name || ''} />
            </div>
            <div className="form-group">
              <label>Company</label>
              <input type="text" value={user?.company || ''} />
            </div>
            <button className="save-btn">Save Changes</button>
          </div>
        </div>
      )}

      {/* Notifications Tab */}
      {activeTab === 'notifications' && (
        <div className="settings-card">
          <h3>Notification Preferences</h3>
          <div className="notifications-list">
            <div className="notification-item">
              <div>
                <h4>Email Notifications</h4>
                <p>Receive email updates about bids and messages</p>
              </div>
              <label className="toggle-switch">
                <input type="checkbox" checked={notifications.emailBids} onChange={() => handleNotificationToggle('emailBids')} />
                <span className="toggle-slider"></span>
              </label>
            </div>
            <div className="notification-item">
              <div>
                <h4>Email Messages</h4>
                <p>Get email when you receive a new message</p>
              </div>
              <label className="toggle-switch">
                <input type="checkbox" checked={notifications.emailMessages} onChange={() => handleNotificationToggle('emailMessages')} />
                <span className="toggle-slider"></span>
              </label>
            </div>
            <div className="notification-item">
              <div>
                <h4>Push Notifications</h4>
                <p>Receive browser notifications for bids</p>
              </div>
              <label className="toggle-switch">
                <input type="checkbox" checked={notifications.pushBids} onChange={() => handleNotificationToggle('pushBids')} />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>
        </div>
      )}

      {/* Security Tab */}
      {activeTab === 'security' && (
        <div className="settings-card">
          <h3>Change Password</h3>
          <form onSubmit={handlePasswordChange} className="settings-form">
            <div className="form-group">
              <label>Current Password</label>
              <input type="password" value={passwordData.current} onChange={(e) => setPasswordData({...passwordData, current: e.target.value})} required />
            </div>
            <div className="form-group">
              <label>New Password</label>
              <input type="password" value={passwordData.new} onChange={(e) => setPasswordData({...passwordData, new: e.target.value})} required />
            </div>
            <div className="form-group">
              <label>Confirm New Password</label>
              <input type="password" value={passwordData.confirm} onChange={(e) => setPasswordData({...passwordData, confirm: e.target.value})} required />
            </div>
            <button type="submit" className="save-btn">Update Password</button>
          </form>

          <div className="security-section">
            <h4>Two-Factor Authentication</h4>
            <p>Add an extra layer of security to your account</p>
            <button className="outline-btn">Enable 2FA</button>
          </div>
        </div>
      )}

      {/* Preferences Tab */}
      {activeTab === 'preferences' && (
        <div className="settings-card">
          <h3>Preferences</h3>
          <div className="settings-form">
            <div className="form-group">
              <label>Language</label>
              <select value={language} onChange={(e) => setLanguage(e.target.value)}>
                <option value="en">English</option>
                <option value="ar">العربية</option>
              </select>
            </div>
            <div className="form-group">
              <label>Currency</label>
              <select value={currency} onChange={(e) => setCurrency(e.target.value)}>
                <option value="USD">USD - US Dollar</option>
                <option value="AED">AED - UAE Dirham</option>
                <option value="EUR">EUR - Euro</option>
              </select>
            </div>
            <div className="form-group">
              <label>Time Zone</label>
              <select>
                <option>UTC+04:00 - Dubai</option>
                <option>UTC+08:00 - Singapore</option>
                <option>UTC+00:00 - London</option>
              </select>
            </div>
            <button className="save-btn">Save Preferences</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Settings;